/* ==========================================================================
   Marmotech — grid / list view toggle
   Choice persists across pages and visits, matching the design's intent that
   the toggle is a viewing preference rather than a per-page control.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'marmotech-view-mode';
  var grid = document.querySelector('[data-mt-grid]');
  var buttons = document.querySelectorAll('[data-mt-view]');

  if (!grid || !buttons.length) return;

  function apply(mode) {
    grid.setAttribute('data-view', mode);
    for (var i = 0; i < buttons.length; i++) {
      var isActive = buttons[i].getAttribute('data-mt-view') === mode;
      buttons[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  var stored;
  try {
    stored = window.localStorage.getItem(KEY);
  } catch (error) {
    stored = null; // Private mode / storage disabled — fall back to grid.
  }

  apply(stored === 'list' ? 'list' : 'grid');

  for (var i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', function (event) {
      var mode = event.currentTarget.getAttribute('data-mt-view');
      apply(mode);
      try {
        window.localStorage.setItem(KEY, mode);
      } catch (error) {
        /* Preference just won't persist. */
      }
    });
  }
})();
